export default __webpack_public_path__ + "static/media/message_on.43b01f96.png";